import styled from "styled-components";

export const UUID = styled.small(() => ({
  color: "#a0a5c3",
  lineHeight: "100%",
  display: "block",
}));
